module.exports = __webpack_public_path__ + "static/media/banff-36.dd3c5d40.jpg";